// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from './pages/Navbar';
import Hero from './pages/Hero';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import AITools from './pages/AITools';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import Newsletter from './pages/Newsletter';
import Footer from './pages/Footer';
import './App.css';

function ScrollToHashElement() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);

  return null;
}

function Home() {
  return (
    <div className="App">
      <header>
        <Navbar />
      </header>

      {/* Hero Section */}
      <Hero />

      <main className="main-sections max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-20">
        <section id="about"><About /></section>
        <section id="services"><Services /></section>
        <section id="portfolio"><Portfolio /></section>
        <section id="tools"><AITools /></section>
        <section id="blogs"><Blogs /></section>
        <section id="newsletter"><Newsletter /></section>
        <section id="contact"><Contact /></section>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToHashElement />
      <Routes>
        {/* Default Home */}
        <Route path="/" element={<Home />} />

        {/* Blogs Shortcut → redirects to home + #blogs */}
        <Route path="/blogs" element={<Navigate to="/#blogs" replace />} />
        <Route path="/newsletter" element={<Navigate to="/#newsletter" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
